module.exports = __webpack_public_path__ + "static/media/game_detail_back_change.e03d8a60.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/game_detail_back_change.png
// module id = 497
// module chunks = 39